import CommonTips, { CommonTipsType, CommonTipsActionType } from '@src/framework/frame/components/common-tips';
import { i18n } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { isMiniProgram } from '@src/utils/agent';
import { isLogin } from '@tencent/docs-multi-tools';
import { SlideAppError } from '@tencent/slide-sdk-revision';
import { setNewWindowUrl } from '@tencent/tencent_doc_open_url';

declare global {
    interface Window {
        hostname: string;
    }
}

interface ICommonTipsConfig {
    message?: string;
    commonTipsType?: string;
    errorCode?: number;
    closable?: boolean;
    actionType?: number;
    autoClose?: boolean;
    duration?: number;
    customerActions?: Array<any>;
    shouldCloseAfterAction?: boolean;
    onlyShowOne?: boolean
    errCode?: number;
    callBack?: (...params: any) => any;
}

export class ErrCodeListener {
    protected handleSlideAppErrorCode = (info: { code: number, error: SlideAppError }) => {
        const persistent = OnlineEditServices.CollaborationManager()?.getPersistent();
        const hasUnsentChanges = !!persistent?.getMutationsPacks().length;
        const errMaybeWithRecoveryConfig = (() => {
            const baseConfig: ICommonTipsConfig = {
                message: '',
                commonTipsType: CommonTipsType.INFO,
                actionType: CommonTipsActionType.REFRESH,
                onlyShowOne: true,
                errorCode: info.code,
                customerActions: [],
            };
            if (hasUnsentChanges) {
                baseConfig.commonTipsType = CommonTipsType.ERROR;
                baseConfig.actionType = CommonTipsActionType.HOWTODEAL;
                baseConfig.callBack = (actionType: number, fn?: any) => {
                    if (actionType === CommonTipsActionType.CREATE_COPY_DOC) {
                        fn(false);
                    }
                };
            }
            return baseConfig;
        })();
        const infoConfig: ICommonTipsConfig = {
            message: '',
            commonTipsType: CommonTipsType.INFO,
            actionType: CommonTipsActionType.REFRESH,
            onlyShowOne: true,
            errorCode: info.code,
        };
        const saveError = () => {
            errMaybeWithRecoveryConfig.message = `${i18n.t('保存失败')}(${info.code === 0 ? `${info.error}` : info.code})`;
            CommonTips.getInstance().show(errMaybeWithRecoveryConfig);
        };
        const connectError = () => {
            infoConfig.message = i18n.t('网络连接超时，请刷新');
            CommonTips.getInstance().show(infoConfig);
        };
        const handleMap: {
            [key in SlideAppError]: () => void
        } = {
            [SlideAppError.None]: () => {},
            [SlideAppError.Cancel]: () => {},
            [SlideAppError.Unknown]: saveError,
            [SlideAppError.ServerError]: saveError,
            [SlideAppError.DataError]: saveError,
            [SlideAppError.FullRoom]: () => {
                this.handleSocketShutdown4FullRoom(
                    infoConfig,
                    info.code,
                );
            },
            [SlideAppError.Timeout]: connectError,
            [SlideAppError.LoginExpired]: () => {
                // 小程序强制走登录逻辑，防止 cookie 过期导致功能异常
                // 参见：http://oncall.oa.com/workBench?id=947144
                if (isMiniProgram() || !isLogin()) {
                    infoConfig.message = i18n.t('帐号信息过期，请重新登录');
                    infoConfig.actionType = CommonTipsActionType.LOGIN;
                } else {
                    infoConfig.message = i18n.t('登录已失效，请刷新');
                    infoConfig.actionType = CommonTipsActionType.REFRESH;
                }
                CommonTips.getInstance().show(infoConfig);
            },
            [SlideAppError.AuthExpired]: () => {
                errMaybeWithRecoveryConfig.message = i18n.t('你的权限已发生变化，编辑内容暂无法保存');
                CommonTips.getInstance().show(errMaybeWithRecoveryConfig);
            },
            [SlideAppError.SizeLimit]: () => {
                errMaybeWithRecoveryConfig.message = i18n.t('修改内容超过限制，编辑内容暂无法保存');
                CommonTips.getInstance().show(errMaybeWithRecoveryConfig);
            },
            [SlideAppError.SecurityStrike]: () => {
                errMaybeWithRecoveryConfig.message = i18n.t('此内容因违规无法编辑。');
                Reflect.deleteProperty(errMaybeWithRecoveryConfig, 'actionType');
                errMaybeWithRecoveryConfig.customerActions = [{
                    text: i18n.t('了解更多'),
                    onClick: () => {
                        CommonTips.getInstance().hide();
                        const url = `https://${window.hostname}/doc/DWE9lbGhWTU9OV2VF?opendocxfrom=admin`;
                        setNewWindowUrl(window, url);
                    },
                }];
                CommonTips.getInstance().show(errMaybeWithRecoveryConfig);
            },
        };
        if (handleMap[info.error]) {
            handleMap[info.error]();
            return;
        }
        saveError();
    };

    private handleSocketShutdown4FullRoom = (commonTipsConfig: ICommonTipsConfig, code: number) => {
        // FIXME: 重新使用下列代码时需要注入依赖 services 的引用，不可以使用 AppServiceProvider
        // 70001代表非会员超员情况
        // if (code === 70001) {
        //     // 进入只读状态
        //     this.getUserPrivilegeService().isOverCoorperateNum = true;
        //     this.getUserPrivilegeService().pptEditorState = PPTEditorStateType.COPYABLE;
        //     const currentSlide = this.getSelectionService()?.currentSlide;
        //     if (currentSlide) {
        //         currentSlide.pptEditorState = PPTEditorStateType.COPYABLE;
        //     }
        //     const clientVars = SlideDataServices.ClientVarsService()?.getClientVars();
        //     const param = {
        //         errorCode: code,
        //         nickName: typeof clientVars?.userName !== 'undefined' ? clientVars.userName : i18n.t('访客'),
        //     };
        //     VipToastService.getInstance().showVipToast(param);
        //     return;
        // }
        CommonTips.getInstance().show(Object.assign(commonTipsConfig, {
            message: i18n.t('可编辑人数已达上限，如需编辑请稍后刷新重试。'),
        }));
        return;
    };

    // private keepTipsShow = (commonTipsConfig: ICommonTipsConfig) => {
    //     // 需要block页面并不可关闭的tip，需保证不被其他tip覆盖
    //     if (!window.pray().isPlaying) {
    //         CommonTips.getInstance().show(commonTipsConfig);
    //     } else {
    //         CommonTips.getInstance().storage(commonTipsConfig);
    //     }
    // };
}
